export const isIOS = ()=>{
  return /iP(hone|ad)/.test(navigator.userAgent) || /iP(hone|ad)/.test(navigator.platform)
}